import {
    Base64
} from 'js-base64';

/**
 * Manage the how data are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 **/
const StorageService = {
    getItem(key, jsonParse = false, base64Decode = false) {
        let item = localStorage.getItem(key);

        if (item === 'undefined' || item === null) {
            return false;
        }

        try {
            if (base64Decode) {
                // item = atob(item);
                item = Base64.decode(item);
            }

            if (jsonParse) {
                item = JSON.parse(item);
            }
        } catch (e) {
            item = false;
        }

        return item;
    },

    saveItem(key, value, base64Encode = false) {
        if (typeof value === "object") {
            value = JSON.stringify(value);
        }

        if (base64Encode) {
            // value = btoa(value);
            value = Base64.encode(value);
        }

        localStorage.setItem(key, value);
    },

    removeItem(key) {
        localStorage.removeItem(key)
    },

    clean() {
        localStorage.clear();
    },
}

export default StorageService